import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=c6b357ba&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=c6b357ba&lang=less&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&id=c6b357ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b357ba",
  null
  
)

export default component.exports